import React, { useContext } from "react";
import { AppContainer } from "@riag-libs/etax-pattern-library";
import AuthService from "../services/AuthService";
import { owTheme } from "@riag-libs/etax-pattern-library/lib/css/owTheme/owTheme";
import HeaderDefault from "../components/HeaderDefault/HeaderDefault";
import MainActivation from "../components/Activation/MainActivation";
import { Footer } from "../components/Footer/Footer";
import { nwTheme } from "@riag-libs/etax-pattern-library/lib/css/nwTheme/nwTheme";
import { KantonContext } from "../contexts";

function ActivatePage() {
  sessionStorage.clear();
  const kantonInfo = useContext(KantonContext);
  return (
    <AppContainer
      header={
        <HeaderDefault
          userName={AuthService.getUsername()}
          mainText={`Steuerportal aktivieren`}
          displayButtons={false}
          breadcrumbs={[
            { text: "Aktivierung", key: "f1", isCurrentItem: true },
          ]}
          backButtonPath={-1}
        />
      }
      main={<MainActivation />}
      footer={<Footer />}
      appTheme={kantonInfo.kanton === "ow" ? owTheme : nwTheme}
    ></AppContainer>
  );
}

export default ActivatePage;
